import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/onconext.png";
import avatarVideo from "../../assets/avatares/mute-red.webm";
import avatarVideoMp4 from "../../assets/avatares/mute-red.mp4";
import manuelVideo from "../../assets/avatares/juan-salon.webm";
import manuelVideoMp4 from "../../assets/avatares/juan-salon.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import avatarDummy from "../../assets/avatares/avatar-dummy.png";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

//NO USADO!!!

function Scenario1Intro2({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.0
	});

	const transcription = "Cuando me dijeron lo que tenía, no entendía nada. Yo solo sabía que estaba cansado… pero nunca imaginé algo así.<br/>El tratamiento fue duro, pero cuando me dijeron que había respondido, sentí que volvía a respirar. Pensé que podría controlarlo.<br/>Pero con el tiempo la enfermedad volvió… y luego otra vez. Y cada recaída es distinta. Ya no lo vives con sorpresa, lo vives sabiendo lo que viene.<br/>Al final aprendes a convivir con esto, a valorar los días buenos, a seguir con tu vida cuando puedes… a no rendirte.<br/>Pero ahora noto que algo ha cambiado otra vez. Ha vuelto el dolor, aquí en el pecho y en las costillas, y después de todo lo vivido, sé que no es buena señal.<br/>Después de todo lo que he pasado, lo que más me preocupa ahora es acertar con el siguiente paso"

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO1_INSTRUCTIONS);
	};

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.0, "", true);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							className="mt-5"
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "100%",
							}}
						/>
						<img
							src={avatarDummy}
							alt="Avatar dummy"
							style={{
								maxWidth: "100%",
								height: "auto",
							}}
						/>
{/*}
						<video
							ref={videoRef}
							autoPlay
							playsInline
							preload="auto"
							muted
							loop
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
*/}
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur h-100 px-5">
						<div className="recuadro-white txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos txt-red mb-4">
								Presentación del caso clínico
							</h3>
							<p>Actualmente, el componente monoclonal de Juan ha aumentado a 1,4 g/dL y comienza a presentar dolores óseos en la región esternal y costal derecha. Juan es oficialmente un paciente en progresión y triplemente expuesto.</p>
							<div className="d-flex justify-content-center">
								<div className="button-escuchar-paciente mt-4 mb-4"
									onClick={abrirModal}
								>
									Escuchar al paciente
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario1Intro2);
